import templateUrl from './payout-policy-list-container.component.html'

export const PayoutPolicyListContainerComponent = {
    controller: PayoutPolicyListContainerController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        isAdminView: "<"
    }
};

class PayoutPolicyListContainerController { }
